var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"0.5","x2":"66","y2":"0.5","stroke":"white","key":0}),React.createElement("line",{"y1":"15.5","x2":"66","y2":"15.5","stroke":"white","key":1}),React.createElement("line",{"y1":"30.5","x2":"66","y2":"30.5","stroke":"white","key":2})]);
}

Menu.defaultProps = {"width":"66","height":"31","viewBox":"0 0 66 31","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
